/* ==========================================================================
   POLYMERCRAFTS — SERVICE PAGE INTERACTIVITY SCRIPT
   Custom Plastic Fabrication Tab Switching & Carousel Slider
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  // Category Tab Switcher
  const tabPills = document.querySelectorAll('.pc-fab-pill');
  const tabContents = document.querySelectorAll('.pc-fab-category-block');

  if (tabPills.length > 0 && tabContents.length > 0) {
    tabPills.forEach(pill => {
      pill.addEventListener('click', function () {
        const targetCategory = this.getAttribute('data-category-index');

        // Toggle active pill
        tabPills.forEach(p => p.classList.remove('active'));
        this.classList.add('active');

        // Toggle active content block
        tabContents.forEach(content => {
          if (content.getAttribute('data-category-index') === targetCategory) {
            content.style.display = 'block';
            content.classList.add('active');
          } else {
            content.style.display = 'none';
            content.classList.remove('active');
          }
        });
      });
    });
  }
});

// Carousel Scroll Navigation Helper
function pcFabSlide(button, direction) {
  const container = button.closest('.pc-fab-carousel-wrapper');
  if (!container) return;
  const track = container.querySelector('.pc-fab-carousel-track');
  if (!track) return;

  const scrollAmount = track.clientWidth * 0.75;
  track.scrollBy({
    left: direction * scrollAmount,
    behavior: 'smooth'
  });
}

// Our Clients Carousel Navigation Helper
function pcClientsSlide(button, direction) {
  const container = button.closest('.pc-clients-carousel-wrapper');
  if (!container) return;
  const track = container.querySelector('.pc-clients-track');
  if (!track) return;

  const item = track.querySelector('.pc-clients-item');
  const itemWidth = item ? item.offsetWidth + 18 : 220;

  track.scrollBy({
    left: direction * itemWidth,
    behavior: 'smooth'
  });
}

// Our Clients Carousel Autoplay Manager
function initClientsAutoplay() {
  const sections = document.querySelectorAll('.sec__pc-our-clients');
  sections.forEach(sec => {
    const track = sec.querySelector('.pc-clients-track');
    const wrapper = sec.querySelector('.pc-clients-carousel-wrapper');
    if (!track || !wrapper) return;

    const autoplayEnabled = sec.getAttribute('data-autoplay') === 'true';
    const intervalMs = parseInt(sec.getAttribute('data-interval') || '4000', 10);

    if (sec._autoplayTimer) {
      clearInterval(sec._autoplayTimer);
      sec._autoplayTimer = null;
    }

    if (!autoplayEnabled) return;

    function nextSlide() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const item = track.querySelector('.pc-clients-item');
        const itemWidth = item ? item.offsetWidth + 18 : 220;
        track.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }
    }

    sec._autoplayTimer = setInterval(nextSlide, intervalMs);

    wrapper.addEventListener('mouseenter', () => {
      if (sec._autoplayTimer) clearInterval(sec._autoplayTimer);
    });

    wrapper.addEventListener('mouseleave', () => {
      if (autoplayEnabled) {
        if (sec._autoplayTimer) clearInterval(sec._autoplayTimer);
        sec._autoplayTimer = setInterval(nextSlide, intervalMs);
      }
    });
  });
}

// Custom Fabrication Carousel Autoplay Manager
function initFabAutoplay() {
  const sections = document.querySelectorAll('.sec__pc-custom-fabrication');
  sections.forEach(sec => {
    const autoplayEnabled = sec.getAttribute('data-autoplay') === 'true';
    const intervalMs = parseInt(sec.getAttribute('data-interval') || '4000', 10);

    if (sec._fabAutoplayTimer) {
      clearInterval(sec._fabAutoplayTimer);
      sec._fabAutoplayTimer = null;
    }

    if (!autoplayEnabled) return;

    function nextFabSlide() {
      const activeBlock = sec.querySelector('.pc-fab-category-block.active') || 
                          sec.querySelector('.pc-fab-category-block:not([style*="display: none"])');
      if (!activeBlock) return;

      const track = activeBlock.querySelector('.pc-fab-carousel-track');
      if (!track) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const item = track.querySelector('.pc-fab-item');
        const itemWidth = item ? item.offsetWidth + 18 : 250;
        track.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }
    }

    sec._fabAutoplayTimer = setInterval(nextFabSlide, intervalMs);

    const wrappers = sec.querySelectorAll('.pc-fab-carousel-wrapper');
    wrappers.forEach(w => {
      w.addEventListener('mouseenter', () => {
        if (sec._fabAutoplayTimer) clearInterval(sec._fabAutoplayTimer);
      });
      w.addEventListener('mouseleave', () => {
        if (autoplayEnabled) {
          if (sec._fabAutoplayTimer) clearInterval(sec._fabAutoplayTimer);
          sec._fabAutoplayTimer = setInterval(nextFabSlide, intervalMs);
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initClientsAutoplay();
  initFabAutoplay();
});

document.addEventListener('shopify:section:load', function (event) {
  initClientsAutoplay();
  initFabAutoplay();
});
